<div class="title-3x faqs-title">Frequently Asked Questions</div>

<div class="faqs-container">
  <div class="faqs-card-container">
    @for (card of faqCards; track card) {
      <div class="faqs-card-position">
        <i class={{card.icon}} aria-hidden="true"></i>
        <div class="faqs-card">
          <div class="faqs-card-title">{{card.question}}</div>
          <div class="faqs-card-content">{{card.content}}</div>
        </div>
      </div>
    }
  </div>
  <div class="d-flex justify-content-center m-5 bottom-0 start-0" style="position: absolute; z-index: 1;">
    <a class="btn btn-primary btn-round hvr-push ms-5 position-relative" [href]="refineEstimateUrl" data-cy="refine-estimate">Estimate Your Earnings</a>
  </div>
  <div class="faqs-image-container">
    <img src="https://cdn.outdooraccess.com/oa-assets/images/background/background-splash-land.webp" alt="hunter" loading="lazy" >
  </div>
</div>


